import { dataAddPauseSquare } from 'dls-icons-data'
import { createIcon } from '../common'

const IconAddPauseSquare = /*#__PURE__*/createIcon(dataAddPauseSquare)
export default IconAddPauseSquare
